export const environment = {
  production: true,
  loginUrl: 'https://umsapinode.dev10.in/',
  apiBaseUrl: 'http://docapi.dev10.in/api',
};
